<span class="txt-rotate">
    <span class="wrap">{{text}}</span>
</span>